// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3533":"6769e5ab9b3b487a","4092":"0e19735f13e4fe4e","7361":"67a284ad2c60784c","9604":"f392d9ef765bf4ab"}[chunkId] + ".css";
};